export default "__VITE_ASSET__CAeWE$U8__"